import { render, staticRenderFns } from "./SortBackForth.vue?vue&type=template&id=4098360a&scoped=true&"
import script from "./SortBackForth.vue?vue&type=script&lang=js&"
export * from "./SortBackForth.vue?vue&type=script&lang=js&"
import style0 from "./SortBackForth.vue?vue&type=style&index=0&id=4098360a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4098360a",
  null
  
)

export default component.exports